import { render, staticRenderFns } from "./AccessGroup.vue?vue&type=template&id=a5bf32be"
import script from "./AccessGroup.vue?vue&type=script&lang=js"
export * from "./AccessGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5bf32be')) {
      api.createRecord('a5bf32be', component.options)
    } else {
      api.reload('a5bf32be', component.options)
    }
    module.hot.accept("./AccessGroup.vue?vue&type=template&id=a5bf32be", function () {
      api.rerender('a5bf32be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Endpoints/AccessGroup.vue"
export default component.exports